import Request from 'utils/request';
import Cookie from 'js-cookie'
export default class HeaderNavServ {
    static getAppList(params) {
        return Request({
            url:`api/user/v1/application/tenant/${Cookie.get("tenant_id")}/instances`,
            method:'GET',
            data:params,
        });
    }
}


// WEBPACK FOOTER //
// ./src/widget/HeaderNav/HeaderNavServ.js